import React, { useEffect, useState } from "react";
import { READY_EMPLOYER, VideoOrientation } from "../../constants";
import { JobInnerColumn } from "./jobLayoutElements";
import { Slide, Stack } from "@mui/material";
import JobVerticalVideoAd from "./JobVerticalVideoAd";

// This component is a wrapper for the third column of the job panel
// Usually, it will display {children} in a <JobInnerColumn> as normal
// When the selected job has a portrait style ad, it will display the ad instead

const ThirdColumnVideoAdWrapper = ({ auth, selectedIdx, mobile, children }) => {
  const [slideIn, setSlideIn] = useState(false);
  const showVideo =
    auth.jobs &&
    selectedIdx !== null &&
    auth.jobs[selectedIdx].vidUrl &&
    auth.jobs[selectedIdx].vidSize === VideoOrientation.portrait &&
    READY_EMPLOYER;
  useEffect(() => {
    if (showVideo) {
      setTimeout(() => {
        setSlideIn(true);
      }, 10);
    } else {
      setSlideIn(false);
    }
  }, [showVideo]);

  if (showVideo) {
    return (
      <Slide
        direction="left"
        in={slideIn}
        mountOnEnter
        unmountOnExit
        timeout={500}>
        <Stack
          sx={{
            width: "100%",
            position: mobile ? "static" : "sticky",
            top: mobile ? "0px" : "12px",
            zIndex: mobile ? 0 : 1,
            alignSelf: mobile ? "" : "flex-start", // necessary for sticky in flexbox
          }}
          direction="column"
          spacing={2}
          alignItems="center">
          <JobVerticalVideoAd job={auth.jobs[selectedIdx]} mobile={mobile} />
        </Stack>
      </Slide>
    );
  }

  return <JobInnerColumn>{children}</JobInnerColumn>;
};

export default ThirdColumnVideoAdWrapper;
